import angular from "angular";
import noHTMLfilter from "./noHTML.filter";

let noHTMLmodule = angular.module('noHTML.filter', [])
.filter('noHTML', noHTMLfilter)

  .name;

export default noHTMLmodule;



// WEBPACK FOOTER //
// ./client/app/common/filters/noHTML/noHTML.js